module.exports = __webpack_public_path__ + "static/media/walletconnect.5ed03637.svg";